// Utilities
import axios from 'axios';

const state = {
  obj: 'working',
  new_document_object: {},
  error: '',

  margin: null,
};

const mutations = {
  SET_NEW_DOCUMENT(state, payload) {
    state.new_document_object = payload;
  },
  Auth_error(state, payload) {
    state.error = "Ce numéro de document n'existe pas";
  },
};

const actions = {
  getPressRelease({ commit }, Infos) {
    const datacollect = {
      page: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/42HIJKHHF22P3O423D2H/getPressRelease',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deletePressRelease({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/42HIJKHHF22P3O423D2H/deletePressRelease',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchPressRelease({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/42HIJKHHF22P3O423D2H/searchPressRelease',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // Publications

  getPublication({ commit }, Infos) {
    const datacollect = {
      page: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/ENH5ZL4T64ZK88EH4RGZ/getPublication',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deletePublication({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/ENH5ZL4T64ZK88EH4RGZ/deletePublication',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchPublication({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/ENH5ZL4T64ZK88EH4RGZ/searchPublication',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // MEDIA PHOTOS

  getGallery({ commit }, Infos) {
    const datacollect = {
      pageP: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/V844G3425823F14YG2V2/getGallery',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteImageGallery({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/V844G3425823F14YG2V2/deleteImageGallery',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchImageGallery({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/V844G3425823F14YG2V2/searchImageGallery',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // VIDEO

  getGallery({ commit }, Infos) {
    const datacollect = {
      pageP: Infos,
      pageV: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/V844G3425823F14YG2V2/getGallery',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteVideoGallery({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/V844G3425823F14YG2V2/deleteVideoGallery',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchVideoGallery({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/V844G3425823F14YG2V2/searchVideoGallery',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
